export const handleFileDownload = async (apiResponse, defaultFileName) => {
    try {
        console.log('API Response:', apiResponse); // 전체 응답 확인
        console.log('Total files received:', apiResponse.data?.files?.length); // 받은 파일 수 확인

        if (!apiResponse.data) {
            console.log('No data in response');
            return {
                success: false,
                message: "No files to download.",
                type: "NO_DATA"
            };
        }

        // 여러 파일인 경우
        if (apiResponse.data.files) {
            console.log('Multiple files detected:', apiResponse.data.files.length);

            const chunkSize = 5; // 한 번에 10개씩 처리
            const results = [];
            const files = apiResponse.data.files;
            const totalChunks = Math.ceil(files.length / chunkSize);

            for (let i = 0; i < files.length; i += chunkSize) {
                const chunk = files.slice(i, i + chunkSize);
                const currentChunk = Math.floor(i / chunkSize) + 1;
                console.log(`Processing chunk ${currentChunk}/${totalChunks} (${chunk.length} files)`);

                // 각 청크 내의 파일들 처리
                for (const [index, fileData] of chunk.entries()) {
                    const globalIndex = i + index + 1;
                    console.log(`Processing file ${globalIndex}/${files.length}`);
                    try {
                        const result = await downloadSingleFile(fileData);
                        console.log(`Download result for file ${globalIndex}:`, result);
                        results.push(result);
                    } catch (error) {
                        console.error(`Error downloading file ${globalIndex}:`, error);
                        results.push({
                            success: false,
                            fileName: fileData.name,
                            error: error.message
                        });
                    }
                }

                // 청크 완료 후 잠시 대기 (선택사항)
                if (currentChunk < totalChunks) {
                    await new Promise(resolve => setTimeout(resolve, 1000));
                }
            }

            const successCount = results.filter(r => r.success).length;
            return {
                success: true,
                type: "MULTIPLE_FILES",
                results,
                totalFiles: files.length,
                successfulDownloads: successCount,
                message: `Successfully downloaded ${successCount}/${files.length} files`
            };
        }

        // 단일 파일인 경우
        if (apiResponse.data.file) {
            console.log(apiResponse.data.file.name);
            const result = await downloadSingleFile(apiResponse.data.file);
            return {
                success: true,
                type: "SINGLE_FILE",
                ...result
            };
        }

        return {
            success: false,
            message: "No valid file data received.",
            type: "INVALID_DATA"
        };
    } catch (error) {
        console.error('Download error:', error);
        console.error('Error stack:', error.stack); // 스택 트레이스 추가
        return {
            success: false,
            error,
            message: "Error occurred during download",
            type: "ERROR"
        };
    }
};

// 실제 파일 다운로드를 처리하는 내부 함수
const downloadSingleFile = async (fileData) => {
    try {
        console.log('Starting download for file:', fileData.name);
        console.log('File data size:', fileData.data?.length || 'No data');

        let blob;
        if (!fileData.name) {
            console.warn('No filename provided by server, using default name');
        }
        const fileName = fileData.name || 'downloaded_file.xlsx';

        if (fileData.data) {
            console.log('Processing file data...');
            const binaryData = atob(fileData.data);
            console.log('Binary data length:', binaryData.length);

            const bytes = new Uint8Array(binaryData.length);
            for (let i = 0; i < binaryData.length; i++) {
                bytes[i] = binaryData.charCodeAt(i);
            }
            blob = new Blob(
                [bytes],
                { type: fileData.type || 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }
            );
            console.log('Blob created, size:', blob.size);
        } else {
            console.warn('No file data found, creating empty blob');
            blob = new Blob([fileData]);
        }

        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);

        return {
            success: true,
            fileName,
            message: `Successfully downloaded ${fileName}`
        };
    } catch (error) {
        console.error('Error in downloadSingleFile:', error);
        console.error('Error stack:', error.stack);
        return {
            success: false,
            error,
            message: `Failed to download file: ${error.message}`
        };
    }
};